(() => {
    const initializeStarumiProductActions = () => {
        const bar = document.querySelector('[data-starumi-product-sticky-actions]');
        const form = bar?.closest('form[data-type="add-to-cart-form"]');
        const originalAdd = form?.querySelector('[data-btn-addtocart]');
        const addButton = bar?.querySelector('[data-starumi-product-add]');
        const buyNowButton = form?.querySelector('[data-starumi-product-buy-now]');
        const termsCheckbox = form?.querySelector('.global-checkbox--input');

        if (!bar || !form || !originalAdd || !addButton || !buyNowButton || bar.dataset.actionsReady === 'true') return;
        bar.dataset.actionsReady = 'true';

        const showError = (message) => {
            if (window.halo?.showWarning) {
                window.halo.showWarning(message);
            } else {
                window.alert(message);
            }
        };

        const termsAccepted = () => {
            if (!termsCheckbox || termsCheckbox.checked) return true;
            termsCheckbox.focus({ preventScroll: false });
            showError(termsCheckbox.labels?.[0]?.textContent?.trim() || 'Please accept the terms and conditions.');
            return false;
        };

        const canSubmit = () => {
            if (!form.checkValidity()) {
                form.reportValidity();
                return false;
            }
            if (originalAdd.disabled || originalAdd.getAttribute('aria-disabled') === 'true') return false;
            return termsAccepted();
        };

        const syncState = () => {
            const unavailable = originalAdd.disabled || originalAdd.getAttribute('aria-disabled') === 'true';
            const loading = originalAdd.classList.contains('is-loading');
            const disabled = unavailable || loading;
            addButton.disabled = disabled;
            buyNowButton.disabled = disabled;
            addButton.setAttribute('aria-busy', String(loading));
            buyNowButton.setAttribute('aria-busy', String(loading));

            const originalText = originalAdd.textContent.trim().toUpperCase();
            addButton.textContent = unavailable && originalText ? originalText : 'ADD TO CART';
        };

        addButton.addEventListener('click', () => {
            if (!canSubmit()) return;
            addButton.disabled = true;
            originalAdd.click();
            window.setTimeout(syncState, 0);
        });

        let buyNowSubmitting = false;
        buyNowButton.addEventListener('click', async () => {
            if (buyNowSubmitting || !canSubmit()) return;

            buyNowSubmitting = true;
            const buyNowText = buyNowButton.textContent;
            buyNowButton.disabled = true;
            addButton.disabled = true;
            buyNowButton.setAttribute('aria-busy', 'true');
            buyNowButton.textContent = 'LOADING…';

            try {
                const formData = new FormData(form);
                const variantId = String(formData.get('id') || '');
                const quantity = Number.parseInt(String(formData.get('quantity') || '1'), 10);
                const sellingPlan = String(formData.get('selling_plan') || '');
                const attributes = new Map();

                for (const [name, value] of formData.entries()) {
                    const propertyMatch = name.match(/^properties\[(.*)\]$/);
                    if (!propertyMatch || value === '') continue;
                    if (typeof File !== 'undefined' && value instanceof File) {
                        if (value.size > 0) {
                            throw new Error('File uploads must be added to the cart before checkout.');
                        }
                        continue;
                    }
                    attributes.set(propertyMatch[1], String(value));
                }

                if (!/^\d+$/.test(variantId) || !Number.isInteger(quantity) || quantity < 1) {
                    throw new Error('Please select an available product option and quantity.');
                }

                const input = {
                    lines: [{
                        merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
                        quantity,
                        attributes: Array.from(attributes, ([key, value]) => ({ key, value })),
                        ...(sellingPlan ? { sellingPlanId: `gid://shopify/SellingPlan/${sellingPlan}` } : {})
                    }],
                    ...(window.Shopify?.country ? { buyerIdentity: { countryCode: window.Shopify.country } } : {})
                };
                const query = `mutation StarumiBuyNow($input: CartInput!) {
                    cartCreate(input: $input) {
                        cart { id checkoutUrl totalQuantity }
                        userErrors { field message }
                    }
                }`;
                const shopDomain = window.Shopify?.shop || window.location.hostname;
                const response = await fetch(`https://${shopDomain}/api/2026-04/graphql.json`, {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ query, variables: { input } })
                });
                const result = await response.json().catch(() => ({}));
                const payload = result.data?.cartCreate;
                const apiError = result.errors?.[0]?.message || payload?.userErrors?.[0]?.message;

                if (!response.ok || apiError || !payload?.cart?.checkoutUrl) {
                    throw new Error(apiError || 'Unable to create checkout. Please try again.');
                }

                window.location.assign(payload.cart.checkoutUrl);
            } catch (error) {
                showError(error.message || 'Unable to create checkout. Please try again.');
                buyNowSubmitting = false;
                buyNowButton.textContent = buyNowText;
                syncState();
            }
        });

        const stateObserver = new MutationObserver(syncState);
        stateObserver.observe(originalAdd, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'], childList: true, subtree: true });
        form.addEventListener('change', syncState);
        form.addEventListener('input', syncState);
        syncState();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeStarumiProductActions, { once: true });
    } else {
        initializeStarumiProductActions();
    }

    document.addEventListener('shopify:section:load', initializeStarumiProductActions);
})();
